import { pages } from "@/services/requests";
import { ICredit } from "global-types/global.types";
import { useMutation } from "react-query";

function useCredit() {
  const {
    data,
    mutate: mutatePostCredit,
    isLoading: isLoadingCredit,
  } = useMutation((params: ICredit) => pages.postCredit(params));

  return {
    isLoadingCredit,
    data,
    mutatePostCredit,
  };
}

export default useCredit;
